<template>
  <div class="container">
    <h1>Resultado da busca: "{{ this.busca }}"</h1>
    <hr />
  </div>
  <img
    v-if="topovisibility"
    @click="top"
    id="back-to-top"
    src="../../public/totop.png"
    alt="voltar ao topo botão"
  />
  <div>
    <div class="container">
      <div v-if="carregamento" style="margin-bottom: 50px">
        <base-spinner></base-spinner>
      </div>
      <p id="naoencontrado" v-if="termoBuscado.length == 0 && !carregamento">
        Oooops... termo "{{ this.busca }}" não encontrado, tente novamente.
      </p>
      <ul v-if="termoBuscado.length > 0 && !carregamento" style="padding: 0">
        <div class="row">
          <item-produto
            class="col-md col-6 p-1"
            v-for="produto in termoBuscado"
            :key="produto.nomeproduto"
            :nomeproduto="produto.nomeproduto"
            :url="produto.url"
            :detalhes="produto.detalhes"
            :preco="produto.preco"
            :saldo="produto.saldo"
            :codigo="produto.codigo"
            :referencia="produto.referencia"
          >
          </item-produto>
        </div>
      </ul>
    </div>
    <div
      class="pagination-container"
      v-if="termoBuscado.length > 0 && !carregamento"
    >
      <button
        class="pagination-button"
        @click="paginaAnterior"
        :disabled="paginaAtual === 0"
      >
        Anterior
      </button>
      <span class="pagination-info">Página {{ paginaAtual + 1 }}</span>
      <button
        class="pagination-button"
        @click="proximaPagina"
        :disabled="termoBuscado.length < limite"
      >
        Próxima
      </button>
    </div>
  </div>
  <AppFooter />
</template>

<script>
import ItemProduto from "../components/produtos/ItemProduto.vue";
import { mapState } from "vuex";
import router from "@/router";
import AppFooter from "@/components/AppFooter.vue";

export default {
  props: ["tokenTipo", "tokenLoja", "tokenBusca"],
  components: {
    ItemProduto,
    AppFooter,
  },
  data() {
    return {
      isLoading: false,
      topovisibility: false,
      paginaAtual: 0,
      limite: 50,
    };
  },
  computed: {
    ...mapState("empresa", ["empresarodape"]),
    ...mapState("produtos", ["termoBuscado"]),
    ...mapState("produtos", ["categoria"]),
    ...mapState("produtos", ["carregamento"]),

    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    busca() {
      return this.$store.getters["loja/buscaPesquisada"];
    },
  },
  methods: {
    async carregarBusca() {
      await this.$store.dispatch("produtos/carregarBusca", {
        busca: this.busca,
        limite: this.limite,
        pagina: this.paginaAtual,
      });
    },
    paginaAnterior() {
      if (this.paginaAtual > 0) {
        this.paginaAtual--;
        this.carregarBusca();
        this.top();
      }
    },
    proximaPagina() {
      this.paginaAtual++;
      this.carregarBusca();
      this.top();
    },
    async carregarRodape() {
      await this.$store.dispatch("empresa/carregarRodape");
      document.title = this.empresarodape.nome;
    },
    async carregarCategorias() {
      await this.$store.dispatch("produtos/carregarCategorias");
    },
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.carregarBusca();
    this.carregarRodape();
    this.carregarCategorias();
  },
  mounted() {
    if (
      router.currentRoute.value.fullPath ==
      "/" + this.tipo + "/" + this.loja + "/" + "produtos/busca/" + this.busca
    ) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 1145) {
          this.topovisibility = true;
        } else {
          this.topovisibility = false;
        }
      });
    }
  },
  watch: {
    busca() {
      this.paginaAtual = 0;
      this.carregarBusca();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap");
@import "@/styles/variables.css";

h1 {
  color: var(--primary-color);
  margin: 40px;
}

#back-to-top {
  position: fixed;
  width: 80px;
  bottom: 0%;
  right: 0%;
  cursor: pointer;
}

ul {
  list-style: none;
  margin: 2rem auto 4rem;
}

div {
  margin: 0;
  padding: 0;
  margin: auto;
  max-width: 85rem;
}

img {
  margin-left: 1rem;
}

input {
  margin: 0;
  margin: auto;
  width: 90%;
}

#naoencontrado {
  margin-bottom: 100px;
  text-align: center;
  font-size: 20px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.pagination-button {
  background-color: var(--primary-color);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  margin: 0 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.pagination-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-button:hover:not(:disabled) {
  background-color: #011428;
  transform: translateY(-2px);
}

.pagination-info {
  font-size: 18px;
  font-weight: bold;
}

.pagination-button:active {
  transform: translateY(1px);
}
</style>
